import { useQuery } from '@tanstack/react-query'
import { toast } from 'sonner'
import z from 'zod'
import { GET_STORYOUS_TOKEN_QUERY_KEY, STORYOUS_STORAGE_KEY } from '~/features/storyous/constants'
import { resolveJSONParse } from '../../../../shared/utils'

const authResponseSchema = z.object({
  token_type: z.string(),
  expires_at: z.string(),
  access_token: z.string(),
})

export const fetchAuthToken = async () => {
  const savedToken = localStorage.getItem(STORYOUS_STORAGE_KEY)
  const parsedSavedToken = savedToken
    ? z.preprocess(resolveJSONParse, authResponseSchema).safeParse(savedToken)
    : {
        success: false,
        error: { message: 'Storyous token could not be found. Must be refetched' },
        data: null,
      }

  if (parsedSavedToken.success) {
    return parsedSavedToken.data
  }

  const response = await fetch('/api/storyous_auth', {
    method: 'GET',
  })

  const result = await response.json()
  const parsed = authResponseSchema.safeParse(result)

  if (parsed.success) {
    localStorage.setItem(STORYOUS_STORAGE_KEY, JSON.stringify(parsed.data))
    return parsed.data
  } else {
    console.error('Could not parse the returned response', parsed.error)
    toast.error('Could not parse the returned response from Storyous. Check console.')
    throw new Error(parsed.error.message)
  }
}

export const useGetAuthToken = () => {
  return useQuery({
    queryKey: [GET_STORYOUS_TOKEN_QUERY_KEY] as const,
    queryFn: fetchAuthToken,
  })
}
